// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  breadcrumb: null,
  paramsdata: null,
  loader: false,
  clickPass: false
};

// Redux Slice for AudioVideo
const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      return initialState;
    },
    setBreadcrumb(state, { payload }) {
      return {
        ...state,
        breadcrumb: payload,
      };
    },
    setLoader(state, { payload }) {
      return {
        ...state,
        loader: payload
      }
    },
    setParamsData(state, { payload }) {
      return {
        ...state,
        paramsdata: payload
      }
    },
    setClickPass(state, { payload }) {
      return {
        ...state,
        clickPass: payload
      }
    },
  },
});

export const commonSliceActions = commonSlice.actions;

export default commonSlice;
